<div id="menuBar" >
    <div >
        <nav class="navbar mainNavBar" role="navigation">
            <ul class="nav navbar-nav" id="topnav">
                <li>
                    <a class="nav-item nav-link" routerLink="/Home">Home</a>
                </li>
                <li>
                    <a >Enter VOWD</a>
                    <ul class="ChildNav">
                            <li>
                                <a class="nav-item nav-link" routerLink="/AssignUser">Assign User's DOA</a>
                            </li>
                            
                            <li *ngIf="!flgLock">
                                <a class="nav-item nav-link" routerLink="/EnterVowd">Enter VOWD</a>
                                  </li>
                            <li>
                                <a class="nav-item nav-link" routerLink="/AssignContract">Assign Contract</a> 
                            </li>
                        </ul>
                </li>
                <li>
                    <a >Reports</a>
                    <ul class="ChildNav">
                            <li>
                                <a class="nav-item nav-link" routerLink="/VOWDReport">VOWD Details</a>
                            </li>
                            <li>
                                <a class="nav-item nav-link" routerLink="/dropanalysis">Accrual Calculation</a>
                            </li>
                            <li>
                                <a class="nav-item nav-link" routerLink="/ContractdropAnalysis">Contract Calculation</a>
                            </li> 
                            <li>
                                <a class="nav-item nav-link" routerLink="/OpexAccrual">Opex Accrual Metrics</a>
                            </li>
                           
                            <div *ngIf="currentUser != undefined">
                            <li *ngIf="currentUser.Role != undefined && currentUser.Role =='Admin'">
                                <a class="nav-item nav-link" routerLink="/AgingReport">Aging Report</a>
                            </li>
                            <li *ngIf="currentUser.Role != undefined && currentUser.Role =='Admin'">
                                <a class="nav-item nav-link" routerLink="/DropComment">Variance Analysis Report</a>
                            </li>       
                            <li *ngIf="currentUser.Role != undefined && currentUser.Role =='Admin'">
                                <a class="nav-item nav-link" routerLink="/Log">Log Report</a>
                            </li>  
                            <li *ngIf="currentUser.Role != undefined && currentUser.Role =='Admin'">
                                <a class="nav-item nav-link" routerLink="/PaymentDetails">Payment Details</a>
                            </li>  
                            </div>              
                        </ul>
                </li>
                <li *ngIf="currentUser != undefined && currentUser.Role =='Admin'">
                   <!-- <li > -->
                    <a >Administration</a>
                    <ul class="ChildNav">
                        <li>
                            <a class="nav-item nav-link" routerLink="/AdminUserMgmt">User Management</a>
                        </li> 
                            <li>
                                <a class="nav-item nav-link" routerLink="/SetThreshold" >Set Threshold Limit</a>
                            </li>
                            <li>
                                <a class="nav-item nav-link" routerLink="/SetCompliance">Set Compliance/Due Date</a>
                            </li>
                            <li>
                                <a class="nav-item nav-link" routerLink="/SetApprovedDate">Set Approved Date</a>
                            </li>
                                            
                        </ul>
                </li>
                <li>
                    <a target="_blank" href="https://chevron.sharepoint.com/sites/SASBUFN/Comptroller/SitePages/Home.aspx?RootFolder=%2Fsites%2FSASBUFN%2FComptroller%2FShared%20Documents%2FBusiness%20Services%20Group%2FSupport%20Functions%2FAMS%20Help%20Material&FolderCTID=0x012000029ACEDC6429B4448777082A2175388B&View=%7BB7E010D0%2DBFBA%2D4D89%2DA675%2D9AB03255BC21%7D&InitialTabId=Ribbon%2ERead&VisibilityContext=WSSTabPersistence">Help</a>
                </li>
              
            </ul>
        </nav>
    </div>
</div>
